<input #input type="number" (change)="onChange($event)" (keyup)="onChange($event)" hidden>
<form [class]="class" [formGroup]="group" (ngSubmit)="$event.preventDefault()">
  <lib-select class="years" [theme]="theme" formControlName="years" [options]="yearsOptions"></lib-select>
  <span [hidden]="!showMonths" class="lib-spacer-fixed"></span>
  <lib-select [hidden]="!showMonths" [theme]="theme" formControlName="months" [options]="monthsOptions"></lib-select>
</form>
